import React, { useEffect, useState } from "react";
import {
  useGetGeneralPolicyCountry,
  useGetGeneralPolicyUserRole,
} from "../../../hooks/useGeneralService";
import UserGridInfoTable from "./UserGridInfoTable";
import UserInfo from "./UserInfo";
import UserSpecificSetting from "./UserSpecificSetting";
import { getListDepartment } from "../../../axios/Department/DepartmentApi";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { LoadingProvider } from "../../../context/LoadingContext";
import { useRefresh } from "../../../context/RefreshContext";
import { getListGroup } from "../../../axios/Group/GroupUrlApi";
import { getListDesignation } from "../../../axios/Designation/DesignationApi";
import { useAuth } from "../../../context/AuthContext";
import UserInfoEmployeeLeft from "./UserInfoEmployeeLeft";
import UserInfoEmployeeRight from "./UserInfoEmployeeRight";

const UserManagement = () => {
  const { data: countries } = useGetGeneralPolicyCountry();
  const { data: userRoles } = useGetGeneralPolicyUserRole();
  const [selectedRow, setSelectedRow] = useState({});
  const [detailLoading, setDetailLoading] = useState(false);
  const [openEditEmployee, setOpenEditEmployee] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [department, setDepartments] = useState([]);
  const { t } = useTranslation();
  const { refreshData } = useRefresh();
  const { isAdmin } = useAuth();

  const [designation, setDesignation] = useState([])

  useEffect(() => {
    const fetchDataDepartment = async () => {
      try {
        const response = await getListDesignation({ langId: localStorage.getItem("i18nextLngId") });
        setDesignation(response.data.data)
      } catch (error) {
        if (error.response) {
          if (error.response.status !== 401) {
            toast.error(t(error?.response.data.message));
          }
        } else {
          toast.error(t('common.network-timeout'));
        }
      }
    };

    fetchDataDepartment();
  }, [refreshData]);

  useEffect(() => {
    const fetchDataDepartment = async () => {
      try {
        const response = await getListDepartment({
          langId: localStorage.getItem("i18nextLngId"),
        });

        setDepartments([
          {
            id: 0,
            createdAt: "",
            createdBy: "tuhtc@mobile-id.vn",
            departmentName: t("common.no-department-selected"),
            departmentPrefix: "NO",
          },
          ...response.data.data,
        ]);
      } catch (error) {
        if (error.response) {
          if (error.response.status !== 401) {
            toast.error(t(error?.response.data.message));
          }
        } else {
          toast.error(t('common.network-timeout'));
        }
      }
    };

    fetchDataDepartment();
  }, [t, refreshData]);

  const handleRowDoubleClick = (employee) => {
    // employee đã là detail từ grid (sau khi gọi getDetailByUser)
    setSelectedRow(employee || {});
    setOpenEditEmployee(true);
  };

  const handleRefreshTable = () => {
    setRefresh((prev) => !prev);
  };

  const [groupData, setGroupData] = useState([]);

  const fetchDataGroup = async () => {
    const payload = {
      pageNo: 1,
      recordPerPage: 500,
      langId: localStorage.getItem("i18nextLngId"),
    };
    try {
      const response = await getListGroup(payload);
      if (response.data.data.length > 0) {
        const listUserGroup = response.data.data;
        setGroupData(listUserGroup);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t('common.network-timeout'));
      }
    }
  };

  useEffect(() => {
    fetchDataGroup();
  }, []);

  useEffect(() => {
    handleRefreshTable(); // toggle refresh local để table reload
    setSelectedRow({});
    setOpenEditEmployee(false);
  }, [refreshData]);

  return (
    <div className="user-management">
      <div
        className={`grid grid-cols-1 gap-4 2xl:gap-5 ${isAdmin ? "2xl:grid-cols-2" : "2xl:grid-cols-2"
          }
          }`}
      >
        {isAdmin ? (
          <>
            <div className="card px-3 py-3">
              <LoadingProvider>
                <UserGridInfoTable
                  userRoles={userRoles}
                  countries={countries}
                  refreshData={refresh}
                  selectedRow={selectedRow}
                  onRowClick={setSelectedRow}
                  onRowDoubleClick={handleRowDoubleClick}
                  onDetailLoadingChange={setDetailLoading}
                  handleRefreshTable={handleRefreshTable}
                  department={department}
                  groupData={groupData}
                  designation={designation}
                />
              </LoadingProvider>
            </div>

            <div className="flex flex-col gap-y-5 h-auto">
              <UserInfo
                userRoles={userRoles}
                countries={countries}
                info={selectedRow}
                detailLoading={detailLoading}
                handleRefreshTable={handleRefreshTable}
                openEditEmployee={openEditEmployee}
                setOpenEditEmployee={setOpenEditEmployee}
                department={department}
                groupData={groupData}
                designation={designation}
              />
            </div>
          </>
        ) : (
          <>
            <div className="flex flex-col gap-y-5 h-auto">
              <UserInfoEmployeeLeft
                userRoles={userRoles}
                countries={countries}
                info={selectedRow}
                handleRefreshTable={handleRefreshTable}
                openEditEmployee={openEditEmployee}
                setOpenEditEmployee={setOpenEditEmployee}
                department={department}
                groupData={groupData}
                designation={designation}
              />
            </div>

            <div className="flex flex-col gap-y-5 h-auto">
              <UserInfoEmployeeRight
                userRoles={userRoles}
                countries={countries}
                info={selectedRow}
                handleRefreshTable={handleRefreshTable}
                openEditEmployee={openEditEmployee}
                setOpenEditEmployee={setOpenEditEmployee}
                department={department}
                groupData={groupData}
                designation={designation}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UserManagement;
